import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import { WithDataFetchParams } from '@shared/redux/commons.types';
import { updateClusterConfig } from './update-cluster.api';

export const UPDATE_CLUSTER_REQUEST_CALLED = '@clusters/UPDATE_CLUSTER_REQUEST_CALLED';

export const UPDATE_CLUSTER_REQUEST_SUCCEEDED = '@clusters/UPDATE_CLUSTER_REQUEST_SUCCEEDED';
export const UPDATE_CLUSTER_REQUEST_FAILED = '@clusters/UPDATE_CLUSTER_REQUEST_FAILED';
export const UPDATE_CLUSTER_REQUEST_CANCELED = '@clusters/UPDATE_CLUSTER_REQUEST_CANCELED';

export const SET_UPDATED_CLUSTERS = '@clusters/SET_UPDATED_CLUSTERS';

export const getUpdatedCluster = state => state.omnichannelBudgetManager
    .updateCluster.data;
export const getUpdatedClusterState = state => state.omnichannelBudgetManager
    .updateCluster.loadState;
export const getUpdatedClusterError = state => state.omnichannelBudgetManager
    .updateCluster.error;

export const updateCluster = ({
    clusterId,
    organizationId,
    cluster,
    userId,
}) => ({
    type: UPDATE_CLUSTER_REQUEST_CALLED,
    actionTypes: {
        success: UPDATE_CLUSTER_REQUEST_SUCCEEDED,
        fail: UPDATE_CLUSTER_REQUEST_FAILED,
        canceled: UPDATE_CLUSTER_REQUEST_CANCELED,
    },
    config: updateClusterConfig({
        clusterId,
        organizationId,
        cluster,
        userId,
    }),
});

export const setUpdatedClusters = values => ({
    type: SET_UPDATED_CLUSTERS,
    payload: values,
});

const initialState: WithDataFetchParams<any> = {
    data: {},
    loadState: LOAD_STATE.LOADING,
    error: null,
};

export const updateClusterReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [UPDATE_CLUSTER_REQUEST_CALLED]: (state, action) => ({
        ...state,
        data: action.config.data.cluster,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [UPDATE_CLUSTER_REQUEST_SUCCEEDED]: state => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [UPDATE_CLUSTER_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: {},
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [UPDATE_CLUSTER_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        data: {},
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [SET_UPDATED_CLUSTERS]: (state, action) => ({
        ...state,
        data: action.payload,
    }),
});
